import * as actions from "../../actions/actions";
import React from "react";
import { connect } from "react-redux";
import map from "lodash/map";
import LingoBanner from "./lingo-banner";
import VoteBanner from "./vote-banner";
import DowntimeBanner from "./downtime-banner";
import PrivacyPolicyBanner from "./privacy-policy-banner";

const TestBanner = props => (
    <div>
        <div data-test-dismiss-banner onClick={props.bannerDismiss}>
            test banner
        </div>
    </div>
);

export const TEST_BANNER_KEY = "TEST_BANNER";
const knownBanners = {
    // *** NOTE *** any banner note being used here needs to be removed from ACTIVE_BANNERS object on the server.
    // LINGO: LingoBanner,
    VOTE_2020: VoteBanner,
    // Used for test, don't delete
    [TEST_BANNER_KEY]: TestBanner
};

class Banner extends React.Component {
    componentDidMount() {
        if (this.props.banners && Object.keys(this.props.banners).length) {
            this.props.uiBodyClassAdd("with-top-banner");
        }
    }
    dismissBanner = bannerKey => {
        this.props.uiBodyClassRemove("with-top-banner");
        this.props.bannerDismiss(bannerKey);
    };
    render() {
        return map(this.props.banners, (visible, bannerKey) => {
            let Component = knownBanners[bannerKey];
            if (Component) {
                return (
                    <Component
                        key={bannerKey}
                        bannerKey={bannerKey}
                        bannerDismiss={this.dismissBanner.bind(this, bannerKey)}
                    />
                );
            }
        });
    }
}

function mapStateToProps(state, ownProps) {
    let { banners } = state;
    if (banners) {
        banners = state.banners.all;
        return { banners };
    }

    return {};
}

Banner = connect(mapStateToProps, {
    uiBodyClassAdd: actions.uiBodyClassAdd,
    uiBodyClassRemove: actions.uiBodyClassRemove,
    bannerDismiss: actions.bannerDismiss
})(Banner);

export default Banner;
